import { RootState } from '@/shared/types/state';

/**
 * Selects the current insight ID from the Redux state
 * @param state - The root Redux state
 * @returns The current insight ID or null
 */
export const selectCurrentInsightId = (state: RootState): string | null =>
  state.insights.currentInsightId;

/**
 * Selects the duplication state for insights
 * @param state - The root Redux state
 * @returns Whether an insight is currently being duplicated
 */
export const selectIsDuplicatingInsight = (state: RootState): boolean =>
  state.insights.isDuplicatingInsight;

/**
 * Selects the entire insights state
 * @param state - The root Redux state
 * @returns The complete insights state object
 */
export const selectInsightsState = (state: RootState) => state.insights;
